export default __webpack_public_path__ + "static/media/covid-dashboard.ddd8fb99.png";